import {
  IS_IE_BROWSER
} from '../common/config.js';

import {
  OptionsModalController
} from './options/options-modal.component';
import {
  ServerInfoModalController
} from './server-info/server-info-modal.component.js';

import html2canvas from 'html2canvas';

const getElementChange = (element, styles) => {
  return {
    element: element,
    // initStyle: angular.copy(element.style)
    initStyle: styles.reduce((acc, k) => {
      if ((typeof element.style[k] === 'object' || typeof element.style[k] === 'function')) return acc;
      acc[k] = element.style[k];
      return acc;
    }, {})
  };
};

export class LayoutService {
  constructor(
    $modal,
    $timeout,
    $window,
    $rootScope,
    LocalStorageService,
    CurrentFilterService,
    TreeService,
    CurrentModelService
  ) {
    this.$modal = $modal;
    this.$timeout = $timeout;
    this.$window = $window;
    this.CurrentFilterService = CurrentFilterService;
    this.$rootScope = $rootScope;
    this.LocalStorageService = LocalStorageService;
    this.CurrentModelService = CurrentModelService;

    this.TreeService = TreeService;
    this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if (this.isFirefox) {
      window.onbeforeprint = () => {
        this.beforePrint();
      };
      window.onafterprint = () => {
        this.afterPrint();
      };
    } else {
      this.mediaQueryPrint = window.matchMedia('print');
      this.mediaQueryPrint.addListener(e => this.printHandler(e));
    }

    this.openedFilters = {
      all: false
    };

    this.searchedFilters = {
      all: true,
      searchTrim: ''
    };

    this.options = {
      showSystemKeys: {
        value: this.LocalStorageService.getItem('showSystemKeys', 'false') ===
          'true',
        type: 'boolean',
        label: gettext('Отображать системные клавиши в кейлогере')
      },
      saveInterface: {
        value: this.LocalStorageService.getItem('saveInterface', 'false') === 'true',
        type: 'boolean',
        label: gettext('Сохранять последнее состояние интерфейса')
      },
      defaultLense: {
        value: this.LocalStorageService.getItem('defaultLense', ''),
        type: 'string',
        label: gettext('Линза по умолчанию')
      },
      toNeighboursMinutes: {
        value: parseInt(
          this.LocalStorageService.getItem('toNeighboursMinutes', 10),
          10
        ),
        type: 'number',
        max: 200,
        min: 1,
        label: gettext('Количество минут для "События рядом" (max=200)')
      },
      renewAggregateSeconds: {
        value: parseInt(
          this.LocalStorageService.getItem('renewAggregateSeconds', 240),
          10
        ),
        type: 'number',
        is0: true,
        min: 30,
        label: gettext(
          'Период обновления агрегат бара в секундах, 0 - не обновлять'
        )
      }
    };
  }

  get printWidth() {
    if (!this.$printWidth) {
      this.$printWidth = this.LocalStorageService.getItem('printWidth');
      if (!this.$printWidth) {
        this.$printWidth = '1424px'; //'210mm';
      }
    }
    return this.$printWidth;
  }

  beforePrint(e) {
    this.isPrint = true;
    this.$printWidth = document.body.clientWidth + 'px';
    this.LocalStorageService.setItem('printWidth', this.$printWidth);

    if (!this.$rootScope.$$phase) this.$rootScope.$digest();
    this.$rootScope.$broadcast('splitter1Changed');
    this.$rootScope.$broadcast('beforePrint');
  }

  afterPrint() {
    this.isPrint = false;
    if (!this.$rootScope.$$phase) this.$rootScope.$digest();
    this.$rootScope.$broadcast('splitter1Changed');
    this.$rootScope.$broadcast('afterPrint');
  }

  printHandler(e) {
    if (this.mediaQueryPrint.matches) {
      this.beforePrint(e);
    } else {
      this.afterPrint(e);
    }
  }

  openOptions() {
    return this.$modal
      .open({
        template: require('./options/options-modal.component.html'),
        controller: OptionsModalController,
        resolve: {
          options: () => angular.copy(this.options)
        }
      })
      .result.then(options => {
        Object.keys(options).map(key => {
          this.options[key].value = options[key].value;
          this.LocalStorageService.setItem(key, options[key].value);
        });
        this.$rootScope.$broadcast('optionsChanged');

        if (this.options.saveInterface != options.saveInterface) {
          const listType = this.CurrentFilterService.filter.listType;
          this.CurrentFilterService.filter.listType = '';
          this.$timeout(() => {
            this.CurrentFilterService.filter.listType = listType;
          });
        }
      })
      .catch(res => res);
  }

  openServerInfo() {
    const updateModalSize = () => {
      $('.modal.fade.in').css({
        width: '90%',
        left: '5%',
        height: '90%',
        top: '5%',
        margin: 0
      });

      $('.modal-body2').height(
        window.innerHeight * 0.9 -
        $('.modal-header').outerHeight() -
        $('.modal-footer').outerHeight() -
        20
      );
    };

    return this.$modal
      .open({
        template: require('./server-info/server-info-modal.component.html'),
        controller: ServerInfoModalController,
        resolve: {
          layout: () => {
            this.$timeout(() => {
              updateModalSize();
            }, 100);
          }
        }
      })
      .result.then()
      .catch(res => res);
  }

  getMainFrame() {
    if (
      this.CurrentFilterService &&
      (this.CurrentFilterService.frameUrl ||
        (this.CurrentFilterService.filter &&
          !this.CurrentFilterService.filter.isCard &&
          !this.CurrentFilterService.filter.isDashboard))
    ) {
      return document.querySelector('sc-frame-view iframe');
    } else {
      return null;
    }
  }

  preparePrint(data, isAsImage, errFunction, element) {
    let isResized = !isAsImage; // id some resize happend

    const setLoading = new Promise(resolve => {
      this.CurrentFilterService.imageLoading = true;
      if (!this.$rootScope.$$phase) this.$rootScope.$apply();
      this.$timeout(() => {
        resolve();
      }, 100);
    });

    return setLoading.then(() => {
      const source = {
        element: null,
        changes: [],
        timeout: 200,
        elementResizedEvent: true, //if false "elementResized" event is pushed by elemet's controller (see heatmap.component)
        isNeedCloneSource: IS_IE_BROWSER && isAsImage && !document.querySelector('sc-frame-view iframe') && (
          document.querySelector('sc-facts-table') ||
          document.querySelector('sc-fact-widget') ||
          document.querySelector('sc-chat-viewer') ||
          document.querySelector('sc-fact-thumb')),
        restoreScViewSize: (source) => {
          if (source.isNeedCloneSource) {
            document.body.removeChild(source.element);
          }

          this.CurrentFilterService.imageLoading = false;
          if (!source || !source.changes || !source.changes.length) return;
          source.changes.map(chEl => {
            // chEl.element.removeAttribute('style');
            Object.keys(chEl.initStyle).map(k => {
              if (chEl.element.style[k] !== chEl.initStyle[k]) {
                chEl.element.style[k] = chEl.initStyle[k];
              }
            });
          });
          this.$rootScope.$broadcast('resize');
        }
      };

      if (!element) element = document.querySelector('sc-view');

      const resizedScView = (() => {
        const change = getElementChange(element, ['width', 'height', ]);

        // const k = scView.clientHeight / scView.clientWidth;
        // scView.style.width = isAsImage ? ((window.document.body.clientWidth * 1) + 'px') : this.printWidth;
        if (!isAsImage) element.style.width = this.printWidth;
        const width = element.clientWidth;
        // let height = (60 + width * k) + 'px';
        if (
          element.querySelector('sc-tree') &&
          !element.querySelector('sc-dashboard')
        ) {
          isResized = true;
          source.timeout = 750;
          element.style.height =
            60 +
            this.TreeService.getHeight(this.CurrentModelService.model, data) +
            'px';
        }
        return change;
      })();

      if (isResized) source.changes.push(resizedScView);

      //removing sc-view-tabs
      if (isAsImage) {
        const tabs = element.querySelector('sc-view-tabs');
        if (tabs) {
          source.changes.push(
            (() => {
              const change = getElementChange(tabs, ['display']);
              tabs.style.display = 'none';
              return change;
            })()
          );
        }
      }

      const getElement = () => {
        if (this.CurrentFilterService.filter.isGraph) {
          return element;
        }
        let desiredEl = this.getMainFrame();
        if (desiredEl) {
          if (isResized) {
            let event;
            if (typeof(Event) === 'function') {
              event = new Event('resizeBeforePrint');
            } else {
              event = document.createEvent('Event');
              event.initEvent('resizeBeforePrint', false, true);
            }
            document.body.dispatchEvent(event);
          }
          if (isAsImage) {

            return desiredEl.contentDocument.querySelector('html>body');
          } else {
            return desiredEl;
          }
        }

        desiredEl = element.querySelector('.for-save-as-image');

        if (desiredEl) {
          if (
            desiredEl.tagName.toLowerCase() === 'sc-heatmap' ||
            desiredEl.querySelector('sc-heatmap')
          ) {
            isResized = true;
            source.elementResizedEvent = false;
          }
          source.changes.push(getElementChange(desiredEl, ['position', 'overflow', 'height']));

          desiredEl.style.position = 'static';
          desiredEl.style.overflow = 'visible';
          desiredEl.style.height = 'unset';
          return desiredEl;
        }

        desiredEl = element.querySelector('#datatable');
        if (desiredEl) {
          // source.timeout = 10000;
          source.changes.push(getElementChange(desiredEl, ['position', 'overflow', 'height']));
          desiredEl.style.position = 'static';
          desiredEl.style.overflow = 'visible';
          desiredEl.style.height = 'unset';
          const tBody = desiredEl.querySelector('tBody');
          source.changes.push(getElementChange(tBody, ['position', 'overflow', 'height']));
          tBody.style.position = 'static';
          tBody.style.overflow = 'visible';
          tBody.style.height = 'unset';
          return desiredEl;
        } else return element;
      };

      source.element = getElement();
      if (source.isNeedCloneSource) {
        source.element = source.element.cloneNode(true);
        source.element.querySelectorAll('.dropdown').forEach(e => {
          e.style.display = 'none';
        });
        document.body.appendChild(source.element);
      }
      if (isResized) {
        this.$rootScope.$broadcast('resizeBeforePrint');
        if (source.elementResizedEvent) {
          angular.element(source.element).ready(() => {
            this.$timeout(
              () => this.$rootScope.$broadcast('elementResized'),
              source.timeout
            );
          });
        }
      }

      const promice = new Promise((resolve, reject) => {
        let isEvent = false;
        if (isResized) {
          const deregister = this.$rootScope.$on('elementResized', () => {
            isEvent = true;
            resolve(source);
          });

          this.$timeout(() => {
            if (!isEvent) {
              this.$rootScope.$on('$destroy', deregister());
              reject(
                gettext(
                  'Изображение не может быть получено. Уменьшите количество загружаемых данных.'
                ),
                source
              );
            }
          }, 15000);
        } else {
          this.$timeout(() => {
            resolve(source);
          }, 100);
        }
      });
      return promice;
    });
  }

  printContainer(data, errFunction) {
    this.preparePrint(data, false)
      .then(source => {
        if (source.element.tagName.toUpperCase() === 'IFRAME')
          source.element.contentWindow.print();
        else this.$window.print();
        this.$timeout(() => {
          source.restoreScViewSize(source);
        });
      })
      .catch((message, source) => {
        errFunction(message);
        source.restoreScViewSize(source);
      });
    // .finally(() => this.CurrentFilterService.imageLoading = false);
  }

  saveAsPicture(data, errFunction, element) {
    const saveAsImage = (canvas, filename) => {
      canvas.toBlob(blob => {
        if (!blob) {
          errFunction(
            gettext(
              'Изображение не может быть получено. Уменьшите количество загружаемых данных.'
            )
          );
          return;
        }
        if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          let dt = URL.createObjectURL(blob);
          dt = dt.replace(
            /^data:image\/[^;]*/,
            'data:application/octet-stream'
          );
          dt = dt.replace(
            /^data:application\/octet-stream/,
            'data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=image.svg'
          );
          const link = document.createElement('a');
          link.setAttribute('href', dt);
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      });
    };

    const final = source => {
      this.CurrentFilterService.imageLoading = false;
      source.restoreScViewSize(source);
      if (!this.$rootScope.$$phase) this.$rootScope.$apply();
    };

    this.preparePrint(data, true, errFunction, element)
      .then(source => {
        this.$timeout(() => {
          html2canvas(source.element, {
              onclone: el => {
                console.log('cloned element: .html2canvas-container');
              }
            })
            .then(canvas => {
              saveAsImage(canvas, 'image.png');
              final(source);
            })
            .catch(message => {
              errFunction(message);
              const tmpContainer = source.element.querySelector(
                '.html2canvas-container'
              );
              if (tmpContainer) source.element.removeChild(tmpContainer);
              final(source);
            });
        }, 500);
      })
      .catch(message => {
        errFunction(message);
        final();
      });
  }
}



// WEBPACK FOOTER //
// ./src/core/layout.service.js